import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Email-pay",
  "use": "icon-Email-pay-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-Email-pay\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.333 6.902V5.726h13.334v1.176L10 10.606 3.333 6.902Zm-1.666.474v9.183c0 .46.373.834.833.834h15c.46 0 .833-.373.833-.834V4.893a.833.833 0 0 0-.833-.834h-15a.833.833 0 0 0-.833.834v2.483Zm15 1.433v6.917H3.333V8.809l5.858 3.254c.503.28 1.115.28 1.618 0l5.858-3.254Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol